import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function ProtectedRoute({ element }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // Show a simple loading screen while checking authentication
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#E8F4FD',
        fontSize: '24px',
      }}>
        Loading... ⏳
      </div>
    );
  }

  return isAuthenticated ? element : <Navigate to="/login" replace />;
}

export default ProtectedRoute;
